import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import NotFound from "./NotFound";
import Home from "./pages/home/Home";
import Resume from "./pages/resume/Resume";
import Portfolio from "./pages/portfolio/Portfolio";
import LayoutNoFoot from "./LayoutNoFoot";
import Contact from "./pages/contact/Contact";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Layout />}>
            <Route path="portfolio" element={<Portfolio />} />
          </Route>

          <Route path="/" exact element={<LayoutNoFoot />}>
            <Route index element={<Home />} />
            <Route path="*" element={<NotFound />} />
            <Route path="resume" element={<Resume />} />
            <Route path="contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
